<div class="flex-container signup-saudia">
  <div class="container">
    <section class="signup-form-cont">
      <div class="twoColLayout main-content">
        <div class="registerForm-title-section col">
          <h2 class="title">
            {{content?.['b2b.register.joinsaudiabusiness']}}
          </h2>
          <!-- <p class="link-section m-top-8x">
            &nbsp;
            {{content?.['b2b.register.saudiamemberlogin'].replace('Login', '')}}
            <a
              class="cursor-pointer text-decoration-underline"
              (click)="navigateToLogin()"
              >Login</a
            >
          </p> -->
        </div>

        <form class="form-new">
          <!-- Corporate Information -->
          <div class="f-col">
            <app-corporate-info
              [class.d-none]="!showCorporateInfo"
              (CorporateInfo)="handleFormSubmit($event)"
              (editClicked)="editClicked($event)"
              [EditLink]="EditLink"
              [CorporateHeading]="CorporateHeading"
              [showForm]="showForm"
            ></app-corporate-info>
          </div>

          <!-- Travel Administrator Information -->
          <div class="f-col" [class.d-none]="!showbusinessOwnerInfo">
            <app-business-owner-info
              [corporateInfo]="corporateInfo"
              [showbusinessOwnerform]="showbusinessOwnerform"
              (FormFilled)="handleFormSAve($event)"
              [AgreeDataUsee]="AgreeDataUse"
              (BusinessOwnerInfo)="handleBusinessOwnerInfoSubmit($event)"
              [EditLinkOwner]="EditLinkOwner"
              (EditBusinessownerr)="EditBusinessowner($event)"
            ></app-business-owner-info>
          </div>
        </form>
      </div>
    </section>
  </div>
</div>
